module.exports = __webpack_public_path__ + "img/Anytime Fitness2.0361626f.svg";